var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombinedShapeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 6,
    viewBox: "0 0 29 6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.5v6.002H0zm3 0h1.5v6.002H3zm3 0h1.5v6.002H6zm3 0h1.5v6.002H9zm3 0h1.5v6.002H12zm3 0h1.5v6.002H15zm3 0h1.5v6.002H18zm3 0h1.5v6.002H21zm3 0h1.5v6.002H24zm3 0h1.5v6.002H27z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombinedShapeIcon);
export default __webpack_public_path__ + "static/media/combined-shape-icon.9c318cd3aa4f2248522d241d0c76bc89.svg";
export { ForwardRef as ReactComponent };